import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/add-field")({
    beforeLoad: ({ location }) => {
        throw redirect({
            to: "/dashboard/fields/add",
            search: location.search,
            hash: location.hash,
            replace: true,
        });
    },
});
